import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import type { DataSourceIconTone } from "./DataSourceIcon.types";

const toneColors: Record<
  DataSourceIconTone,
  { background: string; foreground: string }
> = {
  dataSource: {
    background: rawColors.accent.amberLight,
    foreground: rawColors.accent.amber500,
  },
  schema: {
    background: rawColors.accent.greenLight,
    foreground: rawColors.accent.green,
  },
};

/** Figma data-source category icon: 32×32, 8px radius, accent tint fill, no stroke. */
export const IconContainer = styled.div<{ $tone: DataSourceIconTone }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${borderRadius.lg};
  border: none;
  background-color: ${({ $tone }) => toneColors[$tone].background};
  color: ${({ $tone }) => toneColors[$tone].foreground};
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;
